<template>
    <div class="h-screen flex">
        <main class="flex-1 relative z-0 overflow-y-auto focus:outline-none" tabindex="0" scroll-region>
            <slot />
        </main>
    </div>
</template>

<script>
export default {
    components: {},
};
</script>
